/*====================================
    樣板 相關功能Factory

    Author : Gray
    最後更新時間 : 2017 / 05 / 22
====================================*/

window.InifECShared.factory("TemplateService", ['$q', '$http', 'Upload', 'ShoppingCartService', function($q, $http, Upload, ShoppingCartService) {

    var factory = this;

    // --------------------------------
    // 建立樣板
    // --------------------------------
    var addTemplate = function(templateName, productid, spec, addCount, processRemark, userRemark, supplier) {

        var defer = $q.defer();
        
        $http({
            url: SECURE_INIFEC_URL + "/TemplateAction.do",
            method: "POST",
            data: $.param({
                op: "addTemplate",
                templateName: templateName,
                productid: productid,
                spec: spec,
                addCount: addCount,
                processRemark: processRemark,
                userRemark: userRemark,
                supplier: supplier,
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : TemplateService.addTemplate request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // --------------------------------
    // 取得樣板列表
    // --------------------------------
    var getTemplateList = function(start, len) {

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/TemplateAction.do",
            method: "GET",
            params: {
                op: "getTemplateList",
                start: start,
                len: len,
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : TemplateService.getTemplateList request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // --------------------------------
    // 刪除樣板
    // --------------------------------
    var removeTemplate = function(templateid) {

        var defer = $q.defer();
        
        $http({
            url: SECURE_INIFEC_URL + "/TemplateAction.do",
            method: "POST",
            data: $.param({
                op: "removeTemplate",
                templateid: templateid,
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : TemplateService.removeTemplate request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // --------------------------------
    // 使用樣板加入購物車
    // --------------------------------
    var addTemplateToShoppingCart = function(templateid, isChangeTemplate, changeTemplateRemark, productid, spec, addCount, processRemark, userRemark, supplier) {

        var defer = $q.defer();
        
        $http({
            url: SECURE_INIFEC_URL + "/TemplateAction.do",
            method: "POST",
            data: $.param({
                op: "addTemplateToShoppingCart",
                templateid: templateid,
                isChangeTemplate: isChangeTemplate,
                changeTemplateRemark: changeTemplateRemark,
                productid: productid,
                spec: spec,
                addCount: addCount,
                processRemark: processRemark,
                userRemark: userRemark,
                supplier: supplier
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {
            	ShoppingCartService.getShoppingCart(true);
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : TemplateService.addTemplateToShoppingCart request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // ------------------------------
    // 上傳檔案
    // ------------------------------
    var uploadTemplateFile = function(templateid, file) {

        var defer = $q.defer();

        // 超過單檔上限就不送（大檔還會被 nginx 413 擋下，而 413 不帶 CORS header，前端只看得到網路錯誤）
        if (!checkUploadFileSize(file)) {
            defer.reject({code: 'error.upload.fileTooLarge'});
            return defer.promise;
        }

        file.progress = 0;

        var fd = new FormData();

        fd.append('op', 'uploadTemplateFile');
        fd.append('file', file);
        fd.append('templateid', templateid);
        fd.append('filename', file.name);

        // 分流到 upload 子網域時，先確認登入等條件都正常才開始傳（見 global.js 的 precheckUploadServlet）
        var defaultUploadUrl = SECURE_INIFEC_URL + "/UploadServlet";
        var uploadUrl = getUploadServletUrl(defaultUploadUrl, file);

        precheckUploadServlet($http, $q, uploadUrl, defaultUploadUrl, 'uploadTemplateFile').then(function() {

            Upload.http({
                url: uploadUrl, 
                data: fd,
                transformRequest: angular.identity,
                headers: {'Content-Type': undefined},            
                withCredentials: true
            })
            // $http.post("/UploadServlet", fd, {
            //     transformRequest: angular.identity,
            //     headers: {'Content-Type': undefined}
            // })
            .progress(function(evt) {
                var percent = parseInt(100.0 * evt.loaded / evt.total);
                file.progress = percent;
            })
            .success(function(data){
                if (data.error) {
                    defer.reject(data.error);
                } else {                                    
                    defer.resolve(data);
                }
            }).error(function(data, status, headers, config) {
                defer.reject(data);
                console.error("[InifEC Error] : TemplateService.uploadTemplateFile error.");
                console.error("status : " + status);
            });

        }, function(error) {
            defer.reject(error);
            console.error("[InifEC Error] : 大檔上傳前的檢查失敗", error);
        });

        return defer.promise;
    }

    // ------------------------------
    // 使用之前訂單檔案當樣板
    // ------------------------------
    var uploadTemplateFileFromOrder = function(templateid, orderid, orderitemid) {

        var defer = $q.defer();
        
        $http({
            url: SECURE_INIFEC_URL + "/TemplateAction.do",
            method: "POST",
            data: $.param({
                op: "uploadTemplateFileFromOrder",
                templateid: templateid,
                orderid: orderid,
                orderitemid: orderitemid,
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            withCredentials: true
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : TemplateService.uploadTemplateFileFromOrder request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    /*==========================
        Members
    ==========================*/

    /*==========================
        Methods
    ==========================*/
	factory.addTemplate = addTemplate; // 建立樣板
	factory.getTemplateList = getTemplateList; // 取得樣板列表
	factory.removeTemplate = removeTemplate; // 刪除樣板
	factory.addTemplateToShoppingCart = addTemplateToShoppingCart; // 使用樣板加入購物車
	factory.uploadTemplateFile = uploadTemplateFile; // 上傳檔案
	factory.uploadTemplateFileFromOrder = uploadTemplateFileFromOrder; // 使用之前訂單檔案當樣板

    return factory;
}]);
